/* eslint-disable */
// prettier-ignore
//icons TypeIcon, CreditCardIcon, BoldIcon, ActivityIcon, TypeIcon, LogInIcon, InfoIcon, HeartIcon
export default {
  pages: {
    key: 'title',
    data: [
      { title: 'Landing Page', route: { name: 'landing' }, icon: 'MonitorIcon', isBookmarked: false },
      { title: 'Home', route: { name: 'home' }, icon: 'HomeIcon', isBookmarked: false },
      { title: 'Profile', route: { name: 'profile' }, icon: 'UserIcon', isBookmarked: false },
      { title: 'Quotation', route: { name: 'quotation' }, icon: 'FileTextIcon', isBookmarked: false },
      { title: 'Payments', route: { name: 'payments' }, icon: 'CreditCardIcon', isBookmarked: false },
      { title: 'Offers', route: { name: 'offers' }, icon: 'ListIcon', isBookmarked: false },
      { title: 'Sales', route: { name: 'sales' }, icon: 'TrendingUpIcon', isBookmarked: false },
      { title: 'Terms of Use', route: { name: 'terms' }, icon: 'FileTextIcon', isBookmarked: false },
      { title: 'Privacy Policy', route: { name: 'privacy' }, icon: 'ShieldIcon', isBookmarked: false },
      { title: 'About Us', route: { name: 'about' }, icon: 'UsersIcon', isBookmarked: false },
      { title: 'Contact Us', route: { name: 'contact' }, icon: 'MailIcon', isBookmarked: false },
      { title: 'Affiliate Program', route: { name: 'affiliate' }, icon: 'Share2Icon', isBookmarked: false },
      { title: 'Products', route: { name: 'products' }, icon: 'PackageIcon', isBookmarked: false }
    ],
  },
}
/* eslint-enable */
